'use client';

import { c as _c } from "react/compiler-runtime";
import { Show, reactive, useSelector } from '@legendapp/state/react';
import { $React } from '@legendapp/state/react-web';
import type { ReactNode } from 'react';
import { batch } from '@legendapp/state';
import { FieldWarning } from '@/components/FieldWarning';
import { useHeroBlockSearchFormState } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormProvider';
import { HeroSearchFormColumnButton, type HeroSearchFormColumnButtonProps } from '@/components/forms/HeroBlockSearchForm/components/HeroSearchFormColumnButton';
import { useSearchFromContext } from '@/components/forms/SearchFromProvider';
import { FleetTypeRadioGroup } from '@/components/forms/fields/FleetTypeRadioGroup';
import PromoCodeField from '@/components/forms/fields/PromoCodeField';
import { cn } from '@/lib/cn';
export type HeroSearchFormFleetTypeSelectProps = HeroSearchFormColumnButtonProps;
const ReactiveFleetTypeRadioGroup = reactive(FleetTypeRadioGroup);
const ReactiveHeroSearchFormColumnButton = reactive(HeroSearchFormColumnButton);
const ReactivePromoCodeField = reactive(PromoCodeField);
export function HeroSearchFormFleetTypeSelect(t0) {
  const $ = _c(52);
  let className;
  let description;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      description,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = props;
  } else {
    className = $[1];
    description = $[2];
    props = $[3];
  }
  const {
    triggerId$,
    values,
    variant$,
    warnings$
  } = useHeroBlockSearchFormState();
  const formState$ = useSearchFromContext();
  let t1;
  if ($[4] !== formState$.fleetTypes) {
    t1 = () => formState$.fleetTypes.get();
    $[4] = formState$.fleetTypes;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const fleetTypes = useSelector(t1);
  let t2;
  if ($[6] !== warnings$) {
    t2 = () => warnings$.get();
    $[6] = warnings$;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const warnings = useSelector(t2);
  let t3;
  if ($[8] !== formState$.fleetType || $[9] !== values.fleetType) {
    t3 = function handleClose() {
      batch(() => {
        formState$.fleetType.set(values.fleetType.get());
      });
    };
    $[8] = formState$.fleetType;
    $[9] = values.fleetType;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleClose = t3;
  let t4;
  if ($[11] !== className) {
    t4 = cn("rounded-tl-[100px] rounded-bl-[100px] border-y-0 border-r border-l-0 lg:pl-6 flex-1 min-w-0 max-w-69 basis-69", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== description || $[14] !== fleetTypes || $[15] !== formState$.fleetType) {
    t5 = () => {
      const fleetTypeSlug = formState$.fleetType.get();
      const selectedFleetType = fleetTypes.find(fleetType => fleetType.slug === fleetTypeSlug);
      if (selectedFleetType?.name) {
        return `${selectedFleetType.name} (Must be ${selectedFleetType.minimumDriverAge}+)`;
      }
      return description;
    };
    $[13] = description;
    $[14] = fleetTypes;
    $[15] = formState$.fleetType;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      "data-testid": "fleet-type-card",
      className: "[&_.card-body]:overflow-auto"
    };
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== warnings.fleetType) {
    t7 = warnings.fleetType ? <FieldWarning className="mb-3">{warnings.fleetType as ReactNode}</FieldWarning> : null;
    $[18] = warnings.fleetType;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== values.fleetType) {
    t8 = () => values.fleetType.get();
    $[20] = values.fleetType;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== values.fleetType || $[23] !== warnings$.fleetType) {
    t9 = e => {
      warnings$.fleetType.delete();
      values.fleetType.set(e.target.value);
    };
    $[22] = values.fleetType;
    $[23] = warnings$.fleetType;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== fleetTypes || $[26] !== t8 || $[27] !== t9) {
    t10 = <ReactiveFleetTypeRadioGroup fleetTypes={fleetTypes} name="fleetType" label="Select vehicle type" $value={t8} onChange={t9} />;
    $[25] = fleetTypes;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== values.fleetType) {
    t11 = () => !values.fleetType.get();
    $[29] = values.fleetType;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== handleClose || $[32] !== triggerId$) {
    t12 = () => {
      handleClose();
      triggerId$.set("locations");
    };
    $[31] = handleClose;
    $[32] = triggerId$;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t11 || $[35] !== t12) {
    t13 = <$React.button className="btn btn-primary h-13 mt-auto " data-testid="fleet-type-continue-btn" $disabled={t11} onClick={t12}>Continue</$React.button>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== variant$) {
    t14 = () => variant$.get() === "vertical";
    $[37] = variant$;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== formState$.promoCode) {
    t15 = () => <div className="mx-auto"><ReactivePromoCodeField labelClassName="text-primary" label="Promo code" $value={() => formState$.promoCode.get()} onChange={e_0 => formState$.promoCode.set(e_0.target.value?.trim())} /></div>;
    $[39] = formState$.promoCode;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t14 || $[42] !== t15) {
    t16 = <Show if={t14}>{t15}</Show>;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== props || $[45] !== t10 || $[46] !== t13 || $[47] !== t16 || $[48] !== t4 || $[49] !== t5 || $[50] !== t7) {
    t17 = <ReactiveHeroSearchFormColumnButton className={t4} $description={t5} data-testid="fleet-type-select" data-hero-field="fleetType" cardProps={t6} {...props}>{t7}{t10}{t13}{t16}</ReactiveHeroSearchFormColumnButton>;
    $[44] = props;
    $[45] = t10;
    $[46] = t13;
    $[47] = t16;
    $[48] = t4;
    $[49] = t5;
    $[50] = t7;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  return t17;
}